'use client';

import { ErrorCard } from '@repo/ui/error-card';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    // global-error must include html and body tags
    <html className="h-full w-full">
      <body className="flex h-full w-full items-center justify-center gap-1">
        <ErrorCard
          error={{
            message: error.message,
            details: error.digest,
          }}
          retry={reset}
        />
      </body>
    </html>
  );
}
